import { render, staticRenderFns } from "./ArticleQuestions.vue?vue&type=template&id=e8cb1bd0&"
import script from "./ArticleQuestions.vue?vue&type=script&lang=js&"
export * from "./ArticleQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports